import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const ModalLiberarNoches = ({
  isOpen,
  onClose,
  nochesLiberadas,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          fontWeight="bold"
          fontSize={23}
        >
          {t('RELEASE_NIGHTS_MODAL_TITLE')}
        </ModalHeader>
        <ModalBody>
          <Text fontSize={20}>
            {t('RELEASE_NIGHTS_MODAL_BODY', { nights: nochesLiberadas })}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={onClose}
            colorScheme="red"
            mr={7}
          >
            {t('CANCEL')}
          </Button>
          <Button
            onClick={onConfirm}
            colorScheme="green"
            variant="outline"
          >
            {t('CONFIRM')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
